export default __webpack_public_path__ + "static/media/yd-product.6a040a04.png";